import usePersistedKeyValueStore from './usePersistedKeyValueStore';
import { Platform } from 'react-native';

export type Environment = 'dev' | 'prod';

export type UseEnvironmentReturnValue = Environment | 'loading';

function useEnvironmentMobile(): UseEnvironmentReturnValue {
    const { isLoading, value } = usePersistedKeyValueStore<Environment>({
        category: 'environment',
        key: 'environment',
        defaultValue: 'prod',
    });

    if (isLoading) return 'loading';

    return value;
}

function useEnvironmentWeb(): UseEnvironmentReturnValue {
    // Deliberately lazy. ../webEnvironment is gitignored and written by scripts/setWebEnvironment.js
    // as part of the web build, so it does not exist in a native build tree. A static import would be
    // hoisted and resolved on every platform, breaking iOS/Android; Platform.select below means only
    // web ever calls this.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require('../webEnvironment').webEnvironment;
}

export const useEnvironment = Platform.select({
    web: useEnvironmentWeb,
    default: useEnvironmentMobile,
});
